import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Box } from '@mui/material';
import { z } from 'zod';

const clientBinderSearchSchema = z.object({
  // 'estimates' deep-links the current-year view's payment checklist (estimate reminder emails)
  tab: z.enum(['documents', 'messages', 'from-preparer', 'estimates']).optional().catch(undefined),
});

// The spouse/marital status verification is now handled inline in the pizza tracker
// (ClientTaxBinderDetailPage.tsx) as the first step, rather than via redirect.
export const Route = createFileRoute('/tax-binders/$binderId')({
  validateSearch: clientBinderSearchSchema,
  component: () => (
    <Box>
      <Outlet />
    </Box>
  ),
});
